import { SupportedLang } from './supportedLang';
import enLocale from 'date-fns/locale/en-US';
import deLocale from 'date-fns/locale/de';
import frLocale from 'date-fns/locale/fr';
import itLocale from 'date-fns/locale/it';

type DateLocales = {
  [key in SupportedLang]: Locale;
};

export const dateLocales: DateLocales = {
  en: enLocale,
  de: deLocale,
  fr: frLocale,
  it: itLocale,
  // pl: plLocale,
};
